export function getCurrentDateTime() {
  const currentTime = new Date();
  const hours = currentTime.getHours().toString().padStart(2, '0');
  const minutes = currentTime.getMinutes().toString().padStart(2, '0');
  const formattedDateTime = currentTime.toLocaleDateString('pt-BR') + ' - ' + hours + ':' + minutes;
  return formattedDateTime;
}

export function getCurrentTime() {
  const currentTime = new Date();
  const hours = currentTime.getHours().toString().padStart(2, '0');
  const minutes = currentTime.getMinutes().toString().padStart(2, '0');
  return hours + ':' + minutes;
}

